import React, { KeyboardEvent } from 'react'
import * as S from './ReceivementSearchInput.styles'

interface Props {
  onChangeText: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearch:() => void;
}

const ReceivementSearchInput = ({ onChangeText, handleSearch }: Props) => {
  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation()

    if (e.key === 'Enter') {
      e.preventDefault()
      handleSearch()
    }
  }

  return (
    <S.SearchInputForm>
      <S.InputWrapper>
        <S.Icon />
        <S.Input
          placeholder='Nome do Produto'
          onChange={onChangeText}
          onKeyDown={handleKeyPress}
        />
      </S.InputWrapper>
      <S.Button type='button' onClick={handleSearch}>Buscar</S.Button>
    </S.SearchInputForm>
  )
}

export { ReceivementSearchInput }
